<template>
  <div class="shimmer-card" :class="type"></div>
</template>

<script>
export default {
  name: 'ShimmerLoader',
  props: {
    type: {
      type: String,
      default: 'card', // 'card', 'text', 'avatar'
    },
  },
}
</script>

<style scoped>
.shimmer-card {
  background: #2b2b2b;
  position: relative;
  overflow: hidden;
  border-radius: 8px;
}

/* Shape variants */
.card {
  width: 12.5rem;
  height: 7.5rem;
}

.text {
  width: 80%;
  height: 14px;
  margin: 8px 0;
  border-radius: 4px;
}

.avatar {
  width: 60px;
  height: 60px;
  border-radius: 50%;
}

/* Shimmer effect */
.shimmer-card::after {
  content: '';
  position: absolute;
  top: 0;
  left: -150%;
  width: 50%;
  height: 100%;
  background: linear-gradient(
    90deg,
    transparent,
    rgba(255, 255, 255, 0.08),
    transparent
  );
  animation: shimmer 1.6s infinite;
}

@keyframes shimmer {
  0% { left: -150%; }
  100% { left: 150%; }
}
</style>
